import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { ApplicantChangeRequest } from './applicant-change-model';

@Component({
  selector: 'cs-applicant-change-request',
  standalone: false,
  templateUrl: './applicant-change-request.component.html',
  styleUrls: ['./applicant-change-request.component.scss']
})
export class ApplicantChangeRequestComponent implements OnInit, OnDestroy {
  public applicantChangeRequests: Array<ApplicantChangeRequest>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;
  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getApplicantDetailChangeRequests()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.applicantChangeRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: ApplicantChangeRequest): void {
    this.router.navigate(
      ['/crm/customers/applicant-change-requests/approval'],
      {
        queryParams: { requestId: request.applicantChangeRequestId }
      }
    );
    this.closeTodo.emit();
  }
}
